import { StorageBucket } from "@excel-center/shared";

export const MESSAGING_BUCKET = StorageBucket.MESSAGING_ATTACHMENTS;

export const MESSAGING_SUBJECT_MAX = 200;
export const MESSAGING_BODY_MAX = 10_000;
export const MESSAGING_RECIPIENT_MAX = 200;
export const MESSAGING_ATTACHMENTS_MAX = 10;
/** Per-file cap — attachments above this are rejected client-side. */
export const MESSAGING_ATTACHMENT_MAX_BYTES = 15 * 1024 * 1024;
/** Seconds a signed URL remains valid. Long enough to reach the recipient. */
export const MESSAGING_SIGNED_URL_TTL = 60 * 60 * 24 * 7;
